import { SurveyResponseState } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { ToxnotComponentProperties } from "../BaseApplicationComponents/ToxnotComponent";
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { ToxnotSignInRequiredComponent } from "../BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from '../../../store/Models/UserContext';
import { ApplicationState } from "../../../store";
import { connect } from 'react-redux';
import { ResponseBomType } from "../../../store/Models/Surveys/SurveyDataModel";
import BatchButtons from "../BatchButtons/BatchButtons";

export type BatchProps =
    ToxnotComponentProperties &
    typeof SurveyResponseController.actionCreators &
    SurveyResponseState;

class BulkInputs extends ToxnotSignInRequiredComponent<BatchProps>{
    
    public constructor(props: BatchProps) {
        super(props);
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    protected renderConcreteComponent(): JSX.Element | null {
        const needsMaterialBomResponse = (this.props.coreData?.response?.bomType != ResponseBomType.None) &&
            (!this.props.coreData?.response?.isRevisionResponse || this.props.coreData?.response?.inventoryDataList.some(inv => inv.revisionRequest != null))
            && this.props.coreData?.request?.dataRequested?.materialDisclosureAsked == true;

        /**
         * Handles navigation to the next survey page (same as the main Next button in SurveyNavigation)
         * For Batch page type, this selects the first inventory
         */
        const handleNextPage = () => {
            this.props.setSurveySelectedInventory(0);
            if (this.props.navContext?.currentPageOfMaterialsIndex > 0) {
                this.props.getPaginatedSurveyData(0, true, 0);
            }
        };

        return <BatchButtons localizer={this.props.appServices}
            responseId={this.props.responseId}
            requestId={this.props.coreData?.request?.requestId ?? undefined}
            materialIdsDataToLoadList={this.props.coreData?.materialIdsDataToLoadList}
            requestedData={this.props.coreData?.request?.dataRequested}
            bomQuestionnaireId={this.props.coreData?.request?.bomQuestionnaireId ?? ""}
            needsMaterialBomResponse={needsMaterialBomResponse}
            onNextPage={handleNextPage}
        />
    }
}
export default connect(
    (state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(BulkInputs as any);
